import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcBluePoint = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 7,
		cy: 7,
		r: 3,
		fill: "currentColor"
	})
});
export default SvgIcBluePoint;
